import { createServerFn } from "@tanstack/react-start";
import { whoami } from "@/lib/mma";
import { useAppSession } from "@/utils/session";
import { HEADERS, getRequestIP } from "@tanstack/react-start/server";

export const login = createServerFn({ method: "POST" })
  .inputValidator((data: { username: string; password: string }) => data)
  .handler(async ({ data }) => {
    const requestHeaders = HEADERS;
    //In an environment where a reverse proxy is used, we need to get the client IP from the headers. If no proxy is used, we can get the IP straight from the request object.
    const clientIp = requestHeaders["x-forwarded-for"] || requestHeaders["x-real-ip"] || getRequestIP();
    const token = Buffer.from(`${data?.username}:${data?.password}`).toString("base64");
    const baseUrl = process.env.API_BASE_URL;
    const response = await whoami({
      baseUrl,
      headers: {
        Authorization: `Basic ${token}`,
        Forwarded: `for=${clientIp}`,
      },
    });
    if (response.response.status !== 200) {
      if (response.response.status === 401) {
        throw new Error("Invalid username or password");
      }
      if (response.response.status === 403) {
        throw new Error("User is not active");
      }
      if (response.response.status === 404) {
        throw new Error("User not found");
      }
      if (response.response.status === 500) {
        throw new Error("Internal server error");
      }
      throw new Error("An error occurred while logging in");
    }

    // Create a session
    const session = await useAppSession();

    // Store the user's credentials and other information in the session
    await session.update({
      username: response.data?.data?.username,
      displayName: response.data?.data?.displayName ?? undefined,
      profile: response.data?.data?.profileId?.toString() || "0",
      clientIp: clientIp,
      token,
      baseUrl,
    });
  });
